import React, { FC } from 'react';
import { connect } from 'react-redux';
import { toggleLegend } from '@store/actions';
import { legendVisibilitySelector } from '@selectors/uiSelector';
import useDeviceType from '@hooks/useDeviceType';
import close from '@assets/map-close.svg';
import st from '../Main.module.css';

type MobileBtnOpenLegendProps = {
  visibility: boolean;
  show: boolean;
  onClick: () => void;
};

const MobileBtnOpenLegend: FC<MobileBtnOpenLegendProps> = ({
  visibility,
  show,
  onClick,
}) => {
  const { desktop } = useDeviceType();

  if (visibility && !desktop && show) {
    return (
      <button
        type="button"
        className={st.mobileBtnOpenLegend}
        onClick={() => {
          onClick();
          toggleLegend();
        }}
      >
        <img src={close} alt="close" width={18} height={18} />
      </button>
    );
  }

  return null;
};

const mapDispatchToProps = (dispatch) => ({
  toggleLegend: () => dispatch(toggleLegend()),
});

export default connect(
  (state) => ({
    visibility: legendVisibilitySelector(state),
  }),
  mapDispatchToProps
)(MobileBtnOpenLegend);
